export default {
    WARPED_TO: 'Вы переместились в {{name}}.',

    CANNOT_WARP_ACHIEVEMENT:
        'Перед использованием этого искривления необходимо получить достижение.',
    CANNOT_WARP_QUEST: 'Вы должны завершить {{questName}}, чтобы переместиться в {{name}}.',
    CANNOT_WARP_LEVEL: 'Чтобы переместиться сюда, вы должны иметь уровень не ниже {{level}}.',
    CANNOT_WARP_JAIL: 'Вы не можете переместится, вы заключены в тюрьму еще на {{time}}.',
    CANNOT_WARP_TUTORIAL: 'Перед началом перемещения необходимо завершить обучение.',
    CANNOT_WARP_COMBAT: 'После окончания боя необходимо подождать 10 секунд, чтобы переместиться.',
    CANNOT_WARP_COOLDOWN: 'Вы должны подождать еще {{time}}, чтобы переместиться.'
} as const;
